export default {
  GetErrorMessage(error) {
    var errorMessage = "";
    if (error && error.indexOf('"errorMessage"') > -1) {
      errorMessage = error.substring(error.indexOf("errorMessage") + 14);
      errorMessage = errorMessage.substring(0, errorMessage.indexOf("}"));
    } else if (error && error.indexOf("]") > -1 && error.indexOf("]") > -1) {
      errorMessage = error.substring(error.indexOf("["));
    }
    return errorMessage;
  },

  async GetConfig() {
    var config = {};
    if (location.hostname.indexOf("dnb.avare.no") > -1)
      config = await (await fetch("static/dnbconfig.json")).json();
    else if (location.hostname.indexOf("sb.avare.no") > -1)
      config = await (await fetch("static/sbconfig.json")).json();
    else {     
      if(process.env.VUE_APP_ENV == "production")
        config = await (await fetch("static/prodconfig.json")).json();
      else if(process.env.VUE_APP_ENV == "productionTest")
        config = await (await fetch("static/prodTest.json")).json();
      else
        config = await (await fetch("static/config.json")).json();
    }
    return config;
  },
};
